import moment               from "moment";
import CreatedAt            from "../../../domain/fundamentals/trail/CreatedAt";
import Trail                from "../../../domain/fundamentals/trail/Trail";
import UpdatedAt            from "../../../domain/fundamentals/trail/UpdatedAt";
import Plan                 from "../../../domain/plan/Plan";
import PlanAmount           from "../../../domain/plan/PlanAmount";
import PlanDayLimit         from "../../../domain/plan/PlanDayLimit";
import PlanDescription      from "../../../domain/plan/PlanDescription";
import PlanId               from "../../../domain/plan/PlanId";
import PlanName             from "../../../domain/plan/PlanName";
import PlanStatusType       from "../../../domain/plan/PlanStatusType";
import PlanTaxIncludeType   from "../../../domain/plan/PlanTaxIncludeType";
import PlanTimeType         from "../../../domain/plan/PlanTimeType";
import { PlanResponseType } from "../../api/plan/PlanResponseType";

export const toPlan = (source: PlanResponseType): Plan => new Plan(
  new PlanId(source.id),
  new PlanName(source.name),
  new PlanDescription(source.description),
  new PlanAmount(source.amount),
  toTaxIncludeType(source.tax_include_type),
  toPlanTimeType(source.time_type),
  toPlanStatusType(source.status_type),
  new PlanDayLimit(source.day_limit),
  new Trail(
    new CreatedAt(moment(source.trail.created_at)),
    new UpdatedAt(moment(source.trail.updated_at))
  )
);

const toTaxIncludeType = (source: string): PlanTaxIncludeType => {
  switch (source) {
    default:
    case PlanTaxIncludeType.NOT_INCLUDE:
      return PlanTaxIncludeType.NOT_INCLUDE;
    case PlanTaxIncludeType.INCLUDE:
      return PlanTaxIncludeType.INCLUDE;
  }
};

const toPlanTimeType = (source: string): PlanTimeType => {
  switch (source) {
    default:
    case PlanTimeType.MINUTE_30:
      return PlanTimeType.MINUTE_30;
    case PlanTimeType.MINUTE_120:
      return PlanTimeType.MINUTE_120;
    case PlanTimeType.MINUTE_90:
      return PlanTimeType.MINUTE_90;
    case PlanTimeType.MINUTE_60:
      return PlanTimeType.MINUTE_60;
    case PlanTimeType.MINUTE_15:
      return PlanTimeType.MINUTE_15;
  }
};

const toPlanStatusType = (target: string): PlanStatusType => {
  switch (target) {
    default:
    case PlanStatusType.PRIVATE:
      return PlanStatusType.PRIVATE;
    case PlanStatusType.PUBLISH:
      return PlanStatusType.PUBLISH;
  }
};
